import React from 'react';
import './PrivacyPolicy.css';

const sections = [
  {
    num: '1',
    title: 'Introduction',
    body: (
      <p>
        Welcome to Chalkwalk's Corgif. We are committed to protecting your privacy and ensuring
        that your personal information is handled in a safe and responsible manner. This Privacy
        Policy outlines how we collect, use, disclose, and safeguard your information when you
        visit our website and use our services.
      </p>
    ),
  },
  {
    num: '2',
    title: 'Information We Collect',
    body: (
      <>
        <div className="pp-subsection">
          <h4>Personal Information</h4>
          <ul className="pp-list">
            {['Name', 'Email address', 'Phone number', 'Billing and shipping address', 'Company name (for corporate orders)'].map(i => <li key={i}>{i}</li>)}
          </ul>
        </div>
        <div className="pp-subsection">
          <h4>Payment Information</h4>
          <ul className="pp-list">
            <li>Credit/debit card details (processed securely via third-party payment gateways)</li>
          </ul>
        </div>
        <div className="pp-subsection">
          <h4>Order Information</h4>
          <ul className="pp-list">
            {['Product preferences', 'Order history', 'Custom gifting requirements'].map(i => <li key={i}>{i}</li>)}
          </ul>
        </div>
        <div className="pp-subsection">
          <h4>Technical Data</h4>
          <ul className="pp-list">
            {['IP address', 'Browser type', 'Device information', 'Cookies and usage data'].map(i => <li key={i}>{i}</li>)}
          </ul>
        </div>
      </>
    ),
  },
  {
    num: '3',
    title: 'How We Use Your Information',
    body: (
      <ul className="pp-list">
        {[
          'Process and fulfill orders',
          'Manage corporate gifting requirements',
          'Communicate order updates and support',
          'Improve our website and services',
          'Send promotional emails (only with your consent)',
          'Prevent fraudulent transactions',
        ].map(i => <li key={i}>{i}</li>)}
      </ul>
    ),
  },
  {
    num: '4',
    title: 'Sharing of Information',
    body: (
      <>
        <p>We do not sell your personal information. However, we may share your data with:</p>
        <ul className="pp-list">
          {[
            'Payment gateway providers',
            'Shipping and logistics partners',
            'IT and website service providers',
            'Legal authorities (if required by law)',
          ].map(i => <li key={i}>{i}</li>)}
        </ul>
      </>
    ),
  },
  {
    num: '5',
    title: 'Cookies & Tracking Technologies',
    body: (
      <p>
        We use cookies to enhance user experience, analyze website traffic, and remember user
        preferences. You can disable cookies through your browser settings.
      </p>
    ),
  },
  {
    num: '6',
    title: 'Data Security',
    body: (
      <p>
        We implement appropriate security measures to protect your personal information from
        unauthorized access, alteration, disclosure, or destruction.
      </p>
    ),
  },
  {
    num: '7',
    title: 'Your Rights',
    body: (
      <p>
        You have the right to access your personal data, request correction or deletion, and
        opt-out of marketing communications. Contact:{' '}
        <a href="mailto:sumit@chalkwalkconsulting.com" style={{ color: '#9A1111', fontWeight: 600 }}>
          sumit@chalkwalkconsulting.com
        </a>
      </p>
    ),
  },
  {
    num: '8',
    title: 'Data Retention',
    body: (
      <p>
        We retain your information only as long as necessary for business and legal purposes.
      </p>
    ),
  },
  {
    num: '9',
    title: 'Third-Party Links',
    body: (
      <p>
        Our website may contain links to third-party websites. We are not responsible for their
        privacy practices.
      </p>
    ),
  },
  {
    num: '10',
    title: 'Changes to This Policy',
    body: (
      <p>
        We may update this Privacy Policy from time to time. Changes will be posted on this page
        with an updated effective date.
      </p>
    ),
  },
];

export default function PrivacyPolicy({ onClose }) {
  return (
    <div className="pp-modal-overlay" onClick={onClose}>
      <div className="pp-modal" onClick={(e) => e.stopPropagation()}>

        {/* ── Header ── */}
        <div className="pp-modal-header">
          <div className="pp-modal-header-left">
            <div className="pp-modal-header-icon"><i className="fas fa-shield-alt"></i></div>
            <div>
              <h2>Privacy Policy</h2>
              <span>Effective Date: 15/04/2026 &nbsp;|&nbsp; Chalkwalk's Corgif</span>
            </div>
          </div>
          <button className="pp-modal-close" onClick={onClose}>✕ Close</button>
        </div>

        {/* ── Body ── */}
        <div className="pp-modal-body">

          {/* Intro */}
          <div className="pp-intro">
            <div className="pp-intro-icon"><i className="fas fa-shield-alt"></i></div>
            <div className="pp-intro-text">
              <h3>Your Privacy Matters to Us</h3>
              <p>
                At Chalkwalk's Corgif, we believe in transparency. This policy explains exactly
                what data we collect, why we collect it, and how we keep it safe. Please read it
                carefully — your trust is our priority.
              </p>
            </div>
          </div>

          {/* Sections */}
          {sections.map((s) => (
            <div className="pp-section" key={s.num}>
              <div className="pp-section-header">
                <div className="pp-section-num">{s.num}</div>
                <h2>{s.title}</h2>
              </div>
              <div className="pp-section-body">{s.body}</div>
            </div>
          ))}

          {/* Contact card */}
          <div className="pp-contact-card">
            <div className="pp-contact-item">
              <div className="pp-contact-icon"><i className="fas fa-building"></i></div>
              <div className="pp-contact-info"><h4>Business</h4><p>Chalkwalk's Corgif</p></div>
            </div>
            <div className="pp-contact-item">
              <div className="pp-contact-icon"><i className="fas fa-envelope"></i></div>
              <div className="pp-contact-info">
                <h4>Email</h4>
                <p><a href="mailto:sumit@chalkwalkconsulting.com">sumit@chalkwalkconsulting.com</a></p>
              </div>
            </div>
            <div className="pp-contact-item">
              <div className="pp-contact-icon"><i className="fas fa-phone"></i></div>
              <div className="pp-contact-info"><h4>Phone</h4><p>+91 98236 66128</p></div>
            </div>
            <div className="pp-contact-item" style={{ gridColumn: '1 / -1' }}>
              <div className="pp-contact-icon"><i className="fas fa-map-marker-alt"></i></div>
              <div className="pp-contact-info"><h4>Registered Office</h4><p>402, Gulmohar Orchids, Kharadi - Pune, 411014</p></div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}
